var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7436 9.27276C48.0916 8.80505 47.3084 8.55545 46.5059 8.55962C45.7035 8.5638 44.9229 8.82154 44.2757 9.29601C37.169 14.4459 15.5 31.9764 15.5 54.2499C15.5 66.832 23.0485 77.6665 33.8443 82.5219C31.9972 79.9226 31.0033 76.8136 31 73.6249C30.9341 61.1435 44.7873 46.9145 45.3762 46.4999C45.7033 46.2655 46.0956 46.1394 46.4981 46.1394C46.9005 46.1394 47.2928 46.2655 47.6199 46.4999C48.2089 46.9145 62 58.0241 62 73.6326C62 76.9419 60.9344 79.9993 59.1596 82.5219C69.9515 77.6665 77.5 66.8359 77.5 54.2693C77.5 31.5579 55.8698 14.3296 48.7436 9.27276Z",
    fill: "#DA0067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.30da20f3d3069cb154711f519d36dced.svg";
export { ForwardRef as ReactComponent };